module.exports = __webpack_public_path__ + "img/security-lock.9fec2a31.svg";